export default __webpack_public_path__ + "beta-maps-examples-user-location-view-thumbnail-480-30e008a4af0f8b3faa101c84cbadc9fb.png";